import localeDE from 'moment/locale/de';
import localeCn from 'moment/locale/zh-cn';

export default function getLocale() {
  return {
    de: localeDE,
    cn: localeCn,
  };
}
